var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "spa-soft-footer",
      class: {
        "--fixed": _vm.footerIsFixed,
        "--hidden": _vm.footerIsHidden,
      },
      attrs: { "data-component": "spa-soft-footer" },
    },
    [
      _c("div", { staticClass: "spa-soft-footer-wrapper container" }, [
        _c("div", { staticClass: "spa-soft-footer-continue" }, [
          _vm.nextStepLabel
            ? _c(
                "button",
                {
                  staticClass: "button--primary black size-md primary",
                  class: [{ loading: _vm.isSpaLoading }, _vm.nextStepClass],
                  attrs: { disabled: _vm.hasGuestsWithNoSelectedTreatments },
                  on: { click: _vm.handleClick },
                },
                [
                  _c(
                    "div",
                    { staticClass: "sr-only", attrs: { role: "status" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.isSpaLoading
                              ? _vm.tc("accessibility.loadingButtonStatus")
                              : ""
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v("\n        " + _vm._s(_vm.nextStepLabel) + "\n      "),
                ]
              )
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }